import { render, staticRenderFns } from "./merchantStoreList.vue?vue&type=template&id=10270343&scoped=true&"
import script from "./merchantStoreList.vue?vue&type=script&lang=js&"
export * from "./merchantStoreList.vue?vue&type=script&lang=js&"
import style0 from "./merchantStoreList.vue?vue&type=style&index=0&id=10270343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10270343",
  null
  
)

component.options.__file = "merchantStoreList.vue"
export default component.exports